import React, { useMemo } from 'react'
import Dashboard from '../../components/dashboard/Dashboard'
import TaxDeductionForms from '../../components/dashboard/TaxDeduction'

const Deduction = () => {
  // Simple approach: Use default values, Dashboard will fetch API data for sidebar
  const deductionComparisonData = useMemo(() => {
    const formatCurrency = (value) => {
      return new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Math.abs(value))
    }

    return {
      totalDeductions: 0,
      oldRegimeTaxable: 0,
      newRegimeTaxable: 0,
      difference: 0,
      formatCurrency,
    }
  }, [])

  return (
    <Dashboard 
      salaryData={deductionComparisonData}
      showTaxComparison={true}
    >
      <TaxDeductionForms />
    </Dashboard>
  )
}

export default Deduction